import { Modal as AntdModal, Layout } from "antd";
import { ToggleableProps } from "./Toggleable";
import { Content, Header } from "antd/es/layout/layout";
import { PageContext } from "./Page";
import { KeyboardEventHandler, useContext, useEffect, useRef } from "react";
import { MainContext } from "./MainLayout";

export function Modal(props: {
    children?: React.ReactNode,      
    title?: React.ReactNode,
    toggle?: ToggleableProps,
    onCancel?: () => void,
    onKeyDown?: KeyboardEventHandler<HTMLDivElement> 
    mode?: 'FullPage' | 'FullWindow' | 'AutoPage' | 'AutoWindow',
    focusFirstElement?: boolean
}) {

    let extraProps = {};
    if (props.mode === 'FullPage') {
        extraProps = {
            ...extraProps,
            wrapClassName: "mig-full-page",
            styles: {
                mask: { backgroundColor: "var(--mig-background)", },
            },
            //getContainer: document.querySelector(".mig-page-frame.visible > .ant-layout-content") as HTMLElement
            getContainer: document.querySelector("#mainContent") as HTMLElement
        }
    }

    const { name: pageName } = useContext(PageContext);
    const { selectedPage } = useContext(MainContext);

    const onCancel = () => {
        props.toggle?.hide();
        props.onCancel?.();
    }

    // Focus first element when modal is shown
    const layoutRef = useRef<HTMLElement>(null);
    const contentRef = useRef<HTMLElement>(null);
    const focusFirstElement = props.focusFirstElement ?? true;

    useEffect(() => {
        if (props.toggle?.visible && focusFirstElement) {
            setTimeout(() => {
                if (!contentRef.current) return;

                // Find first focusable element
                const focusableElements = contentRef.current.querySelectorAll(
                    'input, textarea, select'
                );
                const firstFocusable = Array.from(focusableElements).find((el) => {
                    if (el instanceof HTMLElement) {
                        const isVisible =
                            el.offsetParent !== null && // Visible
                            window.getComputedStyle(el).visibility !== "hidden"; // No hidden
        
                        const isEnabled =
                            !(el as HTMLInputElement | HTMLButtonElement).disabled; // No disabled
        
                        return isVisible && isEnabled;
                    }
                    return false;
                }) as HTMLElement;
        
                if (firstFocusable) firstFocusable.focus();
                else layoutRef.current?.focus();
            }, 300);
        }
    }, [props.toggle?.visible, focusFirstElement]);
    
    return (
        //  <Layout className="h-100 mig-modal"> 
        <AntdModal
            open={props.toggle?.visible && pageName===selectedPage}
            onCancel={onCancel}
            footer={null}
            transitionName=""
            className={ props.toggle?.visible? "visible" : "hidden" }
            {...extraProps}
        >
            <Layout ref={layoutRef} className="h-100"  onKeyDown={props.onKeyDown} tabIndex={0} > 
                <Header className="ant-modal-title" style={{paddingBottom: "1em"}}>
                    { props.title || <span>&nbsp;</span>}
                </Header>
                <Content ref={contentRef}>
                    {props.children}
                </Content>
            </Layout>
        </AntdModal>
    );
}
